import { filterEmpty } from '../lists/filterEmpty';
import { getArray } from '../lists/mergeArrays';
import { isEmptyArray } from '../objects/isEmpty';
import { normalizeValue } from './normalizeValue';

export function safeJoin(parts: Array<string | undefined> | undefined, separator = ' '): string | undefined {
	const partsList = getArray(parts);
	const normalized = partsList.map(normalizeValue);
	const filtered = filterEmpty(normalized);

	if (isEmptyArray(filtered)) {
		return undefined;
	}

	const joined = filtered.join(separator);
	return normalizeValue(joined);
}
